var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-indicator-container"},[_c('div',{staticClass:"loading"},[_c('div',{staticClass:"shell"},[_c('div',{staticClass:"bar",style:({ width: _vm.progress + '%' })})])])])}
var staticRenderFns = []

export { render, staticRenderFns }